import { render, staticRenderFns } from "./rubrics_view.vue?vue&type=template&id=3247870e&scoped=true&"
import script from "./rubrics_view.vue?vue&type=script&lang=js&"
export * from "./rubrics_view.vue?vue&type=script&lang=js&"
import style0 from "./rubrics_view.vue?vue&type=style&index=0&id=3247870e&prod&lang=scss&scoped=true&"
import style1 from "./rubrics_view.vue?vue&type=style&index=1&id=3247870e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247870e",
  null
  
)

export default component.exports